//custom code
import './custom/theme';
import './custom/scroller';
import './custom/splide';
import './custom/calendar';
import './custom/rellax';
import './custom/lightbox';

//libraries
// import './lib/fslightbox';

